import React from 'react';
import { Typography } from '@mui/material';

export const AccessError = () => {
  return (
    <Typography align="center" variant="body1" style={{ padding: 12 }}>
      You don't have access to this page.
    </Typography>
  );
};
